import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/PoweredBy.png'


const _withScopeId = n => (_pushScopeId("data-v-26565f1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-block" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = {
  key: 0,
  class: "acquaint-app-home-page"
}
const _hoisted_4 = {
  key: 0,
  class: "full-mode-home-page"
}
const _hoisted_5 = { class: "quadrent" }
const _hoisted_6 = {
  key: 0,
  class: "powered-by-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import UtilitySwitchingAgentPanel from "@/components/home-page/utility-switching-agent-panel.vue";
import UtilitySwitchingCouncilPanel from "@/components/home-page/utility-switching-council-panel.vue";
import HomeIcon from "@/components/icons/home-icon.vue";
import PageHeading from "@/components/ui/labels/page-heading.vue";
import { AppMode } from "@/enums/system/AppMode";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { computed, onMounted, ref } from "vue";
import HomeCarousel from "@/components/home-page/home-carousel.vue";
import { useHomeCarouselStore } from "@/stores/HomeCarouselStore";
import TaskCard from "@/components/home-page/task-card.vue";
import AppointmentsCard from "@/components/home-page/appointments-card.vue";
import JournalCard from "@/components/home-page/journal-card.vue";
import AnnouncementsCard from "@/components/home-page/announcements-card.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'home-page',
  setup(__props) {

const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const homeCarouselStore = useHomeCarouselStore();
const displayCarousel = ref(false);

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
  displayCarousel.value =
    !(await homeCarouselStore.checkIfCarouselHasBeenShown());
  if (displayCarousel.value) {
    homeCarouselStore.carouselHasBeenShown();
  }
});

// Layout
const width = computed(() => {
  if (screen.width < 768) {
    return "100%";
  }
  return "calc(50% - .75rem)";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageHeading, { title: "Home" }, {
        customIcon: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(HomeIcon)
          ])
        ]),
        _: 1
      }),
      (currentUser.value?.appMode == _unref(AppMode).Full)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createVNode(HomeCarousel, {
              modelValue: displayCarousel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayCarousel).value = $event))
            }, null, 8, ["modelValue"]),
            (!displayCarousel.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ width: width.value })
                    }, [
                      _createVNode(TaskCard, { width: "100%" })
                    ], 4),
                    _createElementVNode("div", {
                      style: _normalizeStyle({ width: width.value })
                    }, [
                      _createVNode(AppointmentsCard, { width: "100%" })
                    ], 4),
                    _createElementVNode("div", {
                      style: _normalizeStyle({ width: width.value })
                    }, [
                      _createVNode(JournalCard, { width: "100%" })
                    ], 4),
                    _createElementVNode("div", {
                      style: _normalizeStyle({ width: width.value })
                    }, [
                      _createVNode(AnnouncementsCard, { width: "100%" })
                    ], 4)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (currentUser.value?.appMode == _unref(AppMode).UtilitySwitchingAgent)
        ? (_openBlock(), _createBlock(UtilitySwitchingAgentPanel, { key: 1 }))
        : (currentUser.value?.appMode == _unref(AppMode).UtilitySwitchingCouncil)
          ? (_openBlock(), _createBlock(UtilitySwitchingCouncilPanel, { key: 2 }))
          : _createCommentVNode("", true)
    ]),
    (currentUser.value?.appMode != _unref(AppMode).Full)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}
}

})